// modules
import { createSelector } from 'reselect'

export const careGiverShiftReport$ = (state) =>
  state.reports.caregiversShiftReport

export const careGiverShiftReportList$ = createSelector(
  careGiverShiftReport$,
  ({ careGiverShiftReport = [] }) => careGiverShiftReport
)
